// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  margin-top: 20px;
  text-align: center; }

.login-title-logo {
  margin: 10px auto;
  max-width: 620px;
  display: block; }

.login-title-logo img {
  width: 50%;
  display: block;
  margin: 0 auto 0 auto; }

.preauth-input-form {
  max-width: 620px;
  margin: 20px auto 10% auto;
  text-align: center; }

.preauth-input-form-inner {
  padding-top: 5px;
  background: #f2f2f2;
  border: 1px solid #c0c0c0; }

.preauth-input-form h3 {
  color: #ffffff;
  background: #909092;
  padding: 15px;
  margin-top: 0;
  margin-bottom: 0; }

.input-wrapper {
  display: block;
  margin: 20px;
  background: #ffffff;
  border-radius: 5px; }

.input-wrapper input {
  border: 1px solid #dcdcdc; }

.forgot-password-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  border-radius: 5px;
  color: #4330ff;
  background: #f2f2f2;
  border-width: 1px;
  border-color: #c0c0c0; }

.reset-password-form {
  text-align: center; }
  .reset-password-form input {
    margin-bottom: 10px; }
  .reset-password-form .page-title-nav {
    min-height: 41px; }
  .reset-password-form .submit-button {
    border-radius: 5px;
    min-width: 75%;
    border-width: 1px; }
    .reset-password-form .submit-button:disabled {
      background-color: #eaeaea;
      color: #404040;
      cursor: not-allowed; }

.app-download-callouts .callout {
  display: inline-block;
  margin: 5px; }

.footer {
  margin-top: 15px; }
  .footer .footer-link {
    display: inline-block;
    min-width: 150px; }
    .footer .footer-link a {
      font-size: 12px;
      color: #c0c0c0;
      text-decoration: underline; }
      .footer .footer-link a.footer-link-left {
        float: right; }
      .footer .footer-link a.footer-link-right {
        float: left; }
  .footer .footer-divider {
    display: inline-block;
    color: #c0c0c0;
    margin: 0px 10px 0px 10px; }
`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/loginForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc,EAAE;;AAElB;EACE,UAAU;EACV,cAAc;EACd,qBAAqB,EAAE;;AAEzB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB,EAAE;;AAEtB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB,EAAE;;AAEtB;EACE,yBAAyB,EAAE;;AAE7B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB,EAAE;EACpB;IACE,mBAAmB,EAAE;EACvB;IACE,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB,EAAE;IACnB;MACE,yBAAyB;MACzB,cAAc;MACd,mBAAmB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,WAAW,EAAE;;AAEf;EACE,gBAAgB,EAAE;EAClB;IACE,qBAAqB;IACrB,gBAAgB,EAAE;IAClB;MACE,eAAe;MACf,cAAc;MACd,0BAA0B,EAAE;MAC5B;QACE,YAAY,EAAE;MAChB;QACE,WAAW,EAAE;EACnB;IACE,qBAAqB;IACrB,cAAc;IACd,yBAAyB,EAAE","sourcesContent":[".login-container {\n  margin-top: 20px;\n  text-align: center; }\n\n.login-title-logo {\n  margin: 10px auto;\n  max-width: 620px;\n  display: block; }\n\n.login-title-logo img {\n  width: 50%;\n  display: block;\n  margin: 0 auto 0 auto; }\n\n.preauth-input-form {\n  max-width: 620px;\n  margin: 20px auto 10% auto;\n  text-align: center; }\n\n.preauth-input-form-inner {\n  padding-top: 5px;\n  background: #f2f2f2;\n  border: 1px solid #c0c0c0; }\n\n.preauth-input-form h3 {\n  color: #ffffff;\n  background: #909092;\n  padding: 15px;\n  margin-top: 0;\n  margin-bottom: 0; }\n\n.input-wrapper {\n  display: block;\n  margin: 20px;\n  background: #ffffff;\n  border-radius: 5px; }\n\n.input-wrapper input {\n  border: 1px solid #dcdcdc; }\n\n.forgot-password-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  color: #4330ff;\n  background: #f2f2f2;\n  border-width: 1px;\n  border-color: #c0c0c0; }\n\n.reset-password-form {\n  text-align: center; }\n  .reset-password-form input {\n    margin-bottom: 10px; }\n  .reset-password-form .page-title-nav {\n    min-height: 41px; }\n  .reset-password-form .submit-button {\n    border-radius: 5px;\n    min-width: 75%;\n    border-width: 1px; }\n    .reset-password-form .submit-button:disabled {\n      background-color: #eaeaea;\n      color: #404040;\n      cursor: not-allowed; }\n\n.app-download-callouts .callout {\n  display: inline-block;\n  margin: 5px; }\n\n.footer {\n  margin-top: 15px; }\n  .footer .footer-link {\n    display: inline-block;\n    min-width: 150px; }\n    .footer .footer-link a {\n      font-size: 12px;\n      color: #c0c0c0;\n      text-decoration: underline; }\n      .footer .footer-link a.footer-link-left {\n        float: right; }\n      .footer .footer-link a.footer-link-right {\n        float: left; }\n  .footer .footer-divider {\n    display: inline-block;\n    color: #c0c0c0;\n    margin: 0px 10px 0px 10px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
